import { SvgIconProps } from "@mui/material";

// 3 panes side by side on top (2/3 height), 1 pane spanning the full width
// below (1/3 height).
export const ThreePlusOneIcon = (props: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <rect x="2" y="2" width="6" height="12" rx="1.2" />
    <rect x="9" y="2" width="6" height="12" rx="1.2" />
    <rect x="16" y="2" width="6" height="12" rx="1.2" />
    <rect x="2" y="16" width="20" height="6" rx="1.2" />
  </svg>
);
